import {
  ON_START_GET_MAIL_TEMPLATE,
  ON_ERROR_GET_MAIL_TEMPLATE,
  ON_GET_MAIL_TEMPLATE,
  ON_START_ADD_MAIL_TEMPLATE_SECTION,
  ON_ERROR_ADD_MAIL_TEMPLATE_SECTION,
  ON_ADD_MAIL_TEMPLATE_SECTION,
  ON_RESET_MAIL_RESPONSE,
  ON_START_MOVE_MAIL_TEMPLATE_SECTION,
  ON_ERROR_MOVE_MAIL_TEMPLATE_SECTION,
  ON_MOVE_MAIL_TEMPLATE_SECTION,
  ON_START_UPDATE_MAIL_TEMPLATE_SECTION,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_SECTION,
  ON_UPDATE_MAIL_TEMPLATE_SECTION,
  ON_START_MOVE_MAIL_TEMPLATE_CONTENT,
  ON_ERROR_MOVE_MAIL_TEMPLATE_CONTENT,
  ON_MOVE_MAIL_TEMPLATE_CONTENT,
  ON_START_ADD_MAIL_TEMPLATE_CONTENT,
  ON_ERROR_ADD_MAIL_TEMPLATE_CONTENT,
  ON_ADD_MAIL_TEMPLATE_CONTENT,
  ON_START_ADD_MAIL_TEMPLATE_COLUMN,
  ON_ERROR_ADD_MAIL_TEMPLATE_COLUMN,
  ON_ADD_MAIL_TEMPLATE_COLUMN,
  ON_START_REMOVE_MAIL_TEMPLATE_SECTION,
  ON_ERROR_REMOVE_MAIL_TEMPLATE_SECTION,
  ON_REMOVE_MAIL_TEMPLATE_SECTION,
  ON_START_REMOVE_MAIL_TEMPLATE_CONTENT,
  ON_ERROR_REMOVE_MAIL_TEMPLATE_CONTENT,
  ON_REMOVE_MAIL_TEMPLATE_CONTENT,
  ON_START_REMOVE_MAIL_TEMPLATE_COLUMN,
  ON_ERROR_REMOVE_MAIL_TEMPLATE_COLUMN,
  ON_REMOVE_MAIL_TEMPLATE_COLUMN,
  ON_START_UPDATE_MAIL_TEMPLATE_COLUMN,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_COLUMN,
  ON_UPDATE_MAIL_TEMPLATE_COLUMN,
  ON_START_UPDATE_MAIL_TEMPLATE_CONTENT,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_CONTENT,
  ON_UPDATE_MAIL_TEMPLATE_CONTENT,
  ON_START_UPDATE_MAIL_TEMPLATE_BY_META,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_BY_META,
  ON_UPDATE_MAIL_TEMPLATE_BY_META,
  ON_START_SEND_TEST_MAIL_TEMPLATE,
  ON_ERROR_SEND_MAIL_TEMPLATE,
  ON_SEND_MAIL_TEMPLATE,
  ON_START_ADD_MAIL_TEMPLATE_SOCIAL,
  ON_ERROR_ADD_MAIL_TEMPLATE_SOCIAL,
  ON_ADD_MAIL_TEMPLATE_SOCIAL,
  ON_START_UPDATE_MAIL_TEMPLATE_SOCIAL,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_SOCIAL,
  ON_UPDATE_MAIL_TEMPLATE_SOCIAL,
  ON_START_REMOVE_MAIL_TEMPLATE_SOCIAL,
  ON_ERROR_REMOVE_MAIL_TEMPLATE_SOCIAL,
  ON_REMOVE_MAIL_TEMPLATE_SOCIAL,
  ON_START_MOVE_MAIL_TEMPLATE_SOCIAL,
  ON_ERROR_MOVE_MAIL_TEMPLATE_SOCIAL,
  ON_MOVE_MAIL_TEMPLATE_SOCIAL,
  ON_START_ADD_MAIL_TEMPLATE_EVENT,
  ON_ERROR_ADD_MAIL_TEMPLATE_EVENT,
  ON_ADD_MAIL_TEMPLATE_EVENT,
  ON_START_REMOVE_MAIL_TEMPLATE_EVENT,
  ON_ERROR_REMOVE_MAIL_TEMPLATE_EVENT,
  ON_REMOVE_MAIL_TEMPLATE_EVENT,
  ON_START_UPDATE_MAIL_TEMPLATE_EVENT,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_EVENT,
  ON_UPDATE_MAIL_TEMPLATE_EVENT,
  ON_START_GET_MAIL_TEMPLATE_EVENT,
  ON_ERROR_GET_MAIL_TEMPLATE_EVENT,
  ON_GET_MAIL_TEMPLATE_EVENT,
  ON_START_SEND_URVAL_MAIL_TEMPLATE,
  ON_ERROR_SEND_URVAL_MAIL_TEMPLATE,
  ON_SEND_URVAL_MAIL_TEMPLATE,
  ON_START_GET_URVAL_MAIL_TEMPLATE,
  ON_ERROR_GET_URVAL_MAIL_TEMPLATE,
  ON_GET_URVAL_MAIL_TEMPLATE,
  ON_START_SEND_MAIL_CAMPAIGN,
  ON_ERROR_SEND_MAIL_CAMPAIGN,
  ON_SEND_MAIL_CAMPAIGN,
  ON_START_UPDATE_MAIL_CAMPAIGN,
  ON_ERROR_UPDATE_MAIL_CAMPAIGN,
  ON_UPDATE_MAIL_CAMPAIGN,
  ON_START_DELETE_MAIL_CAMPAIGN,
  ON_ERROR_DELETE_MAIL_CAMPAIGN,
  ON_DELETE_MAIL_CAMPAIGN,
  ON_START_GET_MAIL_TEMPLATE_HTML,
  ON_ERROR_GET_MAIL_TEMPLATE_HTML,
  ON_GET_MAIL_TEMPLATE_HTML,
  ON_SET_CAMP_RECIPIENTS,
  ON_START_CREATE_MAIL_CAMPAIGN_GROUP,
  ON_ERROR_CREATE_MAIL_CAMPAIGN_GROUP,
  ON_CREATE_MAIL_CAMPAIGN_GROUP,
  ON_START_UPDATE_MAIL_CAMPAIGN_GROUP,
  ON_ERROR_UPDATE_MAIL_CAMPAIGN_GROUP,
  ON_UPDATE_MAIL_CAMPAIGN_GROUP,
  ON_START_REMOVE_MAIL_CAMPAIGN_GROUP,
  ON_ERROR_REMOVE_MAIL_CAMPAIGN_GROUP,
  ON_REMOVE_MAIL_CAMPAIGN_GROUP,
  ON_START_GET_MAIL_CAMPAIGN_GROUPS,
  ON_ERROR_GET_MAIL_CAMPAIGN_GROUPS,
  ON_GET_MAIL_CAMPAIGN_GROUPS,

  ON_START_UPDATE_MAIL_CAMPAIGN_RECIPIENT,
  ON_ERROR_UPDATE_MAIL_CAMPAIGN_RECIPIENT,
  ON_UPDATE_MAIL_CAMPAIGN_RECIPIENT,
  ON_START_DELETE_MAIL_CAMPAIGN_RECIPIENT,
  ON_ERROR_DELETE_MAIL_CAMPAIGN_RECIPIENT,
  ON_DELETE_MAIL_CAMPAIGN_RECIPIENT,

  ON_START_GET_MAIL_CAMPAIGN_AUDIENCES,
  ON_ERROR_GET_MAIL_CAMPAIGN_AUDIENCES,
  ON_GET_MAIL_CAMPAIGN_AUDIENCES,
  ON_START_CREATE_MAIL_CAMPAIGN_AUDIENCES,
  ON_ERROR_CREATE_MAIL_CAMPAIGN_AUDIENCES,
  ON_CREATE_MAIL_CAMPAIGN_AUDIENCES,
  ON_START_DELETE_MAIL_CAMPAIGN_AUDIENCES,
  ON_ERROR_DELETE_MAIL_CAMPAIGN_AUDIENCES,
  ON_DELETE_MAIL_CAMPAIGN_AUDIENCES,
  ON_START_UPDATE_MAIL_CAMPAIGN_AUDIENCES,
  ON_ERROR_UPDATE_MAIL_CAMPAIGN_AUDIENCES,
  ON_UPDATE_MAIL_CAMPAIGN_AUDIENCES,

  ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES,
  ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES,
  ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES,
  ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_START_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS ,
  ON_START_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_START_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_START_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_START_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_OPEN_FILTER_CAMPAIGN,ON_ClOSE_FILTER_CAMPAIGN,
  ON_START_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN,
  ON_ERROR_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN,
  ON_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN,SET_CAMPAIGN_FILTER
}  from '../constants/ActionTypes'
import {isUndefined,isEmpty, isNull} from 'lodash'
import { translate } from "../util/intlHelper";

const INIT_STATE = {
  currentMailTemplate: null,
  currentMailTemplateHTML: null,
  response: null,
  sendingCampaign: false,
  mailTemplateEvents: [],
  mailCampaigns: [],
  mailCampaignsLoading: false,
  mailCampaignsCount: 0,
  mailCampaignGroups: [],

  campaignAudiences: [],
  campaignAudiencesCount: 0,
  currentMailAudience: null,
  FilterCampiagnPopup:false,
  CampiagnFilterOption:isUndefined(localStorage.CampaignFilter)?[]:JSON.parse(localStorage.CampaignFilter), 

};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ON_RESET_MAIL_RESPONSE: {
      return {
        ...state,
        response: null
      }
    }
     case ON_OPEN_FILTER_CAMPAIGN: {
      console.log("ON_OPEN_FILTER_USERS", action.payload)
      return {
        ...state, 
        FilterCampiagnPopup:true,
        CampiagnFilterOption:isUndefined(localStorage.CampaignFilter)?[]:JSON.parse(localStorage.CampaignFilter),
        }
      }
      case ON_ClOSE_FILTER_CAMPAIGN: {
        console.log("ON_ClOSE_FILTER_USERS", action.payload)
        return {...state, FilterCampiagnPopup:false}
      }
 case SET_CAMPAIGN_FILTER: {
          console.log("SET_CAMPAIGN_FILTER", action.payload)
          localStorage.removeItem("CampaignFilter");
          localStorage.setItem("CampaignFilter", JSON.stringify(action.payload));
          return {...state, CampiagnFilterOption: action.payload}
        }
    case ON_START_GET_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_START_GET_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_GET_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_ERROR_GET_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.Audiences.get"), }
      }
    }
    case ON_GET_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_GET_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
        campaignAudiences: action.payload.campaignAudiences,
        campaignAudiencesCount: action.payload.campaignAudiencesCount,
      }
    }
    case ON_START_CREATE_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_START_CREATE_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_CREATE_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_ERROR_CREATE_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.Audiences.create"), }
      }
    }
    case ON_CREATE_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_CREATE_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
        campaignAudiences: action.payload.campaignAudiences,
        campaignAudiencesCount: action.payload.campaignAudiencesCount,
        response: {type: 'success', success: true, msg: translate("Action.Campaign.Audiences.create"), }
      }
    }
    case ON_START_DELETE_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_START_DELETE_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_DELETE_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_ERROR_DELETE_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.Audiences.delete"), }
      }
    }
    case ON_DELETE_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_DELETE_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
        campaignAudiences: action.payload.campaignAudiences,
        campaignAudiencesCount: action.payload.campaignAudiencesCount,
        response: {type: 'warning', success: true, msg: translate("Action.Campaign.Audiences.delete"), }
      }
    }
    case ON_START_UPDATE_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_START_UPDATE_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_UPDATE_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_ERROR_UPDATE_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.Audiences.save"), }
      }
    }
    case ON_UPDATE_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_UPDATE_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
        currentMailAudience: action.payload.currentMailAudience,
        response: {type: 'success', success: true, msg: translate("Action.Campaign.Audiences.save"), }
      }
    }

    case ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
        currentMailAudience: null
      }
    }
    case ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.current.get"), }
      }
    }
    case ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES: {
      console.log("ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES", action.payload)
      return {
        ...state,
        currentMailAudience: action.payload.currentMailAudience,
      }
    }
    case ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.Audiences.current.get"), }
      }
    }
    case ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        currentMailAudience: isNull( state.currentMailAudience) 
          ? {recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount} 
          : {...state.currentMailAudience,recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount},
      }
    }
    case ON_START_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_START_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_ERROR_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: action.payload.error ?? translate("Error.Campaign.Audiences.current.create"), }
      }
    }
    case ON_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS : {
      console.log("ON_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        currentMailAudience: isNull( state.currentMailAudience) 
          ? {recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount} 
          : {...state.currentMailAudience,recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount},
        response: {type: 'success', success: true, msg: translate("Action.Campaign.Audiences.current.create"), },
      }
    }
    case ON_START_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_START_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        response: {type: 'INFO', success: true, loading: true, msg: translate("Action.Campaign.Audiences.current.import"), }
      }
    }
    case ON_ERROR_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_ERROR_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: action.payload, }
      }
    }
    case ON_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS : {
      console.log("ON_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        currentMailAudience: isNull( state.currentMailAudience) 
          ? {recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount} 
          : {...state.currentMailAudience,recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount},
        response: {type: 'success', success: true, msg: translate("Action.Campaign.recipients.current.import"), },
      }
    }
    case ON_START_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_START_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_ERROR_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.recipients.current.import"), }
      }
    }
    case ON_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS : {
      console.log("ON_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        currentMailAudience: isNull( state.currentMailAudience) 
          ? {recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount} 
          : {...state.currentMailAudience,recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount},
        response: {type: 'success', success: true, msg: translate("Action.Campaign.recipients.current.save"), },
      }
    }
    case ON_START_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_START_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_ERROR_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.recipients.current.delete"), }
      }
    }
    case ON_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        currentMailAudience: isNull( state.currentMailAudience) 
          ? {recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount} 
          : {...state.currentMailAudience,recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount},
        response: {type: 'warning', success: true, msg: translate("Action.Campaign.recipients.current.delete"), }
      }
    }
    case ON_START_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_START_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_ERROR_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.recipients.current.delete"), }
      }
    }
    case ON_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS: {
      console.log("ON_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS", action.payload)
      return {
        ...state,
        currentMailAudience: isNull( state.currentMailAudience) 
          ? {recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount} 
          : {...state.currentMailAudience,recipients: action.payload.recipients, recipientsCount: action.payload.recipientsCount},
        response: {type: 'warning', success: true, msg: translate("Action.Campaign.recipients.list.delete",`${action.payload.deleteCount} st mottagare har tagits bort`,{item:action.payload.deleteCount}), }
      }
    }

    case ON_SET_CAMP_RECIPIENTS: {
      console.log("ON_SET_CAMP_RECIPIENTS", action.payload)
      return {
        ...state,
        currentMailTemplate: {
          ...state.currentMailTemplate,
          recipients: action.payload.Recipients
        }
      }
    }
    case ON_START_SEND_URVAL_MAIL_TEMPLATE: {
      console.log("ON_START_SEND_URVAL_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
        // mailCampaigns: [],
        // mailCampaignsCount: 0
      }
    }
    case ON_ERROR_SEND_URVAL_MAIL_TEMPLATE: {
      console.log("ON_ERROR_SEND_URVAL_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.send.Choosen"), },
      }
    }
    case ON_SEND_URVAL_MAIL_TEMPLATE: {
      console.log("ON_SEND_URVAL_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_GET_URVAL_MAIL_TEMPLATE: {
      console.log("ON_START_GET_URVAL_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
        mailCampaigns: [],
        mailCampaignsLoading: true,
        mailCampaignsCount: 0
      }
    }
    case ON_ERROR_GET_URVAL_MAIL_TEMPLATE: {
      console.log("ON_ERROR_GET_URVAL_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.get.Choosen"), },
        mailCampaigns: [],
        mailCampaignsLoading: false,
        mailCampaignsCount: 0
      }
    }
    case ON_GET_URVAL_MAIL_TEMPLATE: {
      console.log("ON_GET_URVAL_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
        mailCampaigns:  action.payload.MailCampaigns.array,
        mailCampaignsLoading: false,
        mailCampaignsCount: action.payload.MailCampaigns.count,
      }
    }
    case ON_START_SEND_MAIL_CAMPAIGN: {
      console.log("", action.payload)
      return {
        ...state,
        sendingCampaign: true,
        response: {type: 'error', success: true, msg: translate("Action.Campaign.sending"), loading: true },
      }
    }
    case ON_ERROR_SEND_MAIL_CAMPAIGN: {
      console.log("", action.payload)
      return {
        ...state,
        sendingCampaign: false,
        response: {type: 'error', success: false, msg: action.payload, }
      }
    }
    case ON_SEND_MAIL_CAMPAIGN: {
      console.log("", action.payload)
      return {
        ...state,
        sendingCampaign: false,
        currentMailTemplate: action.payload.MailTemplate,
        response: {type: 'success', success: true, msg: translate("Action.Campaign.send"), },
      }
    }
    case ON_START_UPDATE_MAIL_CAMPAIGN: {
      console.log("", action.payload)
      return {
        ...state,
        sendingCampaign: true,
        response: {type: 'error', success: true, msg: translate("Action.Campaign.saving"), loading: true },
      }
    }
    case ON_ERROR_UPDATE_MAIL_CAMPAIGN: {
      console.log("", action.payload)
      return {
        ...state,
        sendingCampaign: false,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.save"), }
      }
    }
    case ON_UPDATE_MAIL_CAMPAIGN: {
      console.log("", action.payload)
      return {
        ...state,
        sendingCampaign: false,
        currentMailTemplate: action.payload.MailTemplate,
        response: {type: 'success', success: true, msg: translate("Action.Campaign.save"), },
      }
    }
    
    case ON_START_DELETE_MAIL_CAMPAIGN: {
      console.log("ON_START_DELETE_MAIL_CAMPAIGN", action.payload)
      return {
        ...state,
        mailCampaignsLoading: true,
      }
    }
    case ON_ERROR_DELETE_MAIL_CAMPAIGN: {
      console.log("ON_ERROR_DELETE_MAIL_CAMPAIGN", action.payload)
      return {
        ...state,
        mailCampaignsLoading: false,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.delete"), }
      }
    }
    case ON_DELETE_MAIL_CAMPAIGN: {
      console.log("ON_DELETE_MAIL_CAMPAIGN", action.payload)
      return {
        ...state,
        // response: {type: 'warning', success: true, msg: 'Kampanj borttagen', },
        mailCampaigns:  action.payload.MailCampaigns.array,
        mailCampaignsLoading: false,
        mailCampaignsCount: action.payload.MailCampaigns.count,
      }
    }

    case ON_START_UPDATE_MAIL_CAMPAIGN_RECIPIENT: {
      return {
        ...state,
        response: {type: 'info', success: true, msg: translate("Action.Campaign.Recipient.saving"), loading: true },
      }
    }
    case ON_ERROR_UPDATE_MAIL_CAMPAIGN_RECIPIENT: {
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.Recipient.save"), loading: false },
      }
    }
    case ON_UPDATE_MAIL_CAMPAIGN_RECIPIENT: {
      return {
        ...state,
        currentMailTemplate: action.payload.MailTemplate,
        response: {type: 'success', success: true, msg: translate("Action.Campaign.Recipient.save"), },
      }
    }

    case ON_START_DELETE_MAIL_CAMPAIGN_RECIPIENT: {
      return {
        ...state,
        response: {type: 'info', success: true, msg: translate("Action.Campaign.Recipient.deleting"), loading: true },
      }
    }
    case ON_ERROR_DELETE_MAIL_CAMPAIGN_RECIPIENT: {
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.Recipient.delete"), loading: false },
      }
    }
    case ON_DELETE_MAIL_CAMPAIGN_RECIPIENT: {
      return {
        ...state,
        currentMailTemplate: action.payload.MailTemplate,
        response: {type: 'warning', success: true, msg: translate("Action.Campaign.Recipient.delete"), },
      }
    }

    case ON_START_GET_MAIL_TEMPLATE: {
      console.log("ON_START_GET_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
        currentMailTemplate: null,
        response: null
      }
    }
    case ON_ERROR_GET_MAIL_TEMPLATE: {
      console.log("ON_ERROR_GET_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
        currentMailTemplate: null,
        response: {type: 'error', success: false, msg: translate("Error.Mail.Template.get"), }
      }
    }
    case ON_GET_MAIL_TEMPLATE: {
      console.log("ON_GET_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
        currentMailTemplate: action.payload.MailTemplate,
        response: null
      }
    }
    case ON_START_GET_MAIL_TEMPLATE_HTML: {
      console.log("ON_START_GET_MAIL_TEMPLATE_HTML", action.payload)
      return {
        ...state,
        currentMailTemplateHTML: null,
        response: null
      }
    }
    case ON_ERROR_GET_MAIL_TEMPLATE_HTML: {
      console.log("ON_ERROR_GET_MAIL_TEMPLATE_HTML", action.payload)
      return {
        ...state,
        currentMailTemplateHTML: null,
        response: {type: 'error', success: false, msg: translate("Error.Mail.Template.html.get"), }
      }
    }
    case ON_GET_MAIL_TEMPLATE_HTML: {
      console.log("ON_GET_MAIL_TEMPLATE_HTML", action.payload)
      return {
        ...state,
        currentMailTemplateHTML: action.payload.MailTemplateHtml,
        response: null
      }
    }
    case ON_START_ADD_MAIL_TEMPLATE_SECTION: {
      console.log("ON_START_ADD_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
        response: null
      }
    }
    case ON_ERROR_ADD_MAIL_TEMPLATE_SECTION: {
      console.log("ON_ERROR_ADD_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Section.Add"), }
      }
    }
    case ON_ADD_MAIL_TEMPLATE_SECTION: {
      console.log("ON_ADD_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
        response: null
      }
    }
    case ON_START_REMOVE_MAIL_TEMPLATE_SECTION: {
      console.log("ON_START_REMOVE_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
        response: null
      }
    }
    case ON_ERROR_REMOVE_MAIL_TEMPLATE_SECTION: {
      console.log("ON_ERROR_REMOVE_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Section.delete"), }
      }
    }
    case ON_REMOVE_MAIL_TEMPLATE_SECTION: {
      console.log("ON_REMOVE_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
        response: null
      }
    }
    case ON_START_MOVE_MAIL_TEMPLATE_SECTION: {
      console.log("ON_START_MOVE_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_MOVE_MAIL_TEMPLATE_SECTION: {
      console.log("ON_ERROR_MOVE_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Section.move"), }
      }
    }
    case ON_MOVE_MAIL_TEMPLATE_SECTION: {
      console.log("ON_MOVE_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_UPDATE_MAIL_TEMPLATE_SECTION: {
      console.log("ON_START_UPDATE_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_UPDATE_MAIL_TEMPLATE_SECTION: {
      console.log("ON_ERROR_UPDATE_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Section.save"), }
      }
    }
    case ON_UPDATE_MAIL_TEMPLATE_SECTION: {
      console.log("ON_UPDATE_MAIL_TEMPLATE_SECTION", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_MOVE_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_START_MOVE_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_MOVE_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_ERROR_MOVE_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Contant.move"), }
      }
    }
    case ON_MOVE_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_MOVE_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_ADD_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_START_ADD_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_ADD_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_ERROR_ADD_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Contant.add"), }
      }
    }
    case ON_ADD_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_ADD_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_REMOVE_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_START_REMOVE_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_REMOVE_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_ERROR_REMOVE_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Contant.delete"), }
      }
    }
    case ON_REMOVE_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_REMOVE_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_ADD_MAIL_TEMPLATE_COLUMN: {
      console.log("ON_START_ADD_MAIL_TEMPLATE_COLUMN", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_ADD_MAIL_TEMPLATE_COLUMN: {
      console.log("ON_ERROR_ADD_MAIL_TEMPLATE_COLUMN", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Column.add"), }
      }
    }
    case ON_ADD_MAIL_TEMPLATE_COLUMN: {
      console.log("ON_ADD_MAIL_TEMPLATE_COLUMN", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_REMOVE_MAIL_TEMPLATE_COLUMN: {
      console.log("ON_START_REMOVE_MAIL_TEMPLATE_COLUMN", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_REMOVE_MAIL_TEMPLATE_COLUMN: {
      console.log("ON_ERROR_REMOVE_MAIL_TEMPLATE_COLUMN", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Column.delete"), }
      }
    }
    case ON_REMOVE_MAIL_TEMPLATE_COLUMN: {
      console.log("ON_REMOVE_MAIL_TEMPLATE_COLUMN", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_UPDATE_MAIL_TEMPLATE_COLUMN: {
      console.log("ON_START_UPDATE_MAIL_TEMPLATE_COLUMN", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_UPDATE_MAIL_TEMPLATE_COLUMN: {
      console.log("ON_ERROR_UPDATE_MAIL_TEMPLATE_COLUMN", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Contant.save"), }
      }
    }
    case ON_UPDATE_MAIL_TEMPLATE_COLUMN: {
      console.log("ON_UPDATE_MAIL_TEMPLATE_COLUMN", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_UPDATE_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_START_UPDATE_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_UPDATE_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_ERROR_UPDATE_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Contant.save"), }
      }
    }
    case ON_UPDATE_MAIL_TEMPLATE_CONTENT: {
      console.log("ON_UPDATE_MAIL_TEMPLATE_CONTENT", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_UPDATE_MAIL_TEMPLATE_BY_META: {
      console.log("ON_START_UPDATE_MAIL_TEMPLATE_BY_META", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_UPDATE_MAIL_TEMPLATE_BY_META: {
      console.log("ON_ERROR_UPDATE_MAIL_TEMPLATE_BY_META", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Meta.save"), }
      }
    }
    case ON_UPDATE_MAIL_TEMPLATE_BY_META: {
      console.log("ON_UPDATE_MAIL_TEMPLATE_BY_META", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_SEND_TEST_MAIL_TEMPLATE: {
      console.log("ON_START_SEND_TEST_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
        response: {type: 'error', success: true, msg: translate("Action.Main.Template.test.sending"), loading: true },
      }
    }
    case ON_ERROR_SEND_MAIL_TEMPLATE: {
      console.log("ON_ERROR_SEND_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: action.payload, }
      }
    }
    case ON_SEND_MAIL_TEMPLATE: {
      console.log("ON_SEND_MAIL_TEMPLATE", action.payload)
      return {
        ...state,
        response: {type: 'success', success: true, msg: translate("Action.Main.Template.test.send"), },
      }
    }
    case ON_START_ADD_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_START_ADD_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_ADD_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_ERROR_ADD_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Social.add"), }
      }
    }
    case ON_ADD_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_ADD_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_UPDATE_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_START_UPDATE_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_UPDATE_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_ERROR_UPDATE_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Social.save"), }
      }
    }
    case ON_UPDATE_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_UPDATE_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_REMOVE_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_START_REMOVE_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_REMOVE_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_ERROR_REMOVE_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Social.delete"), }
      }
    }
    case ON_REMOVE_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_REMOVE_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
      }
    }
    case ON_START_MOVE_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_START_MOVE_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_MOVE_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_ERROR_MOVE_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.Social.move"), }
      }
    }
    case ON_MOVE_MAIL_TEMPLATE_SOCIAL: {
      console.log("ON_MOVE_MAIL_TEMPLATE_SOCIAL", action.payload)
      return {
        ...state,
      }
    }

    case ON_START_ADD_MAIL_TEMPLATE_EVENT: {
      console.log("ON_START_ADD_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_ADD_MAIL_TEMPLATE_EVENT: {
      console.log("ON_ERROR_ADD_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.event.add"), }
      }
    }
    case ON_ADD_MAIL_TEMPLATE_EVENT: {
      console.log("ON_ADD_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
        mailTemplateEvents: action.payload.mailTemplateEvents
      }
    }
    case ON_START_REMOVE_MAIL_TEMPLATE_EVENT: {
      console.log("ON_START_REMOVE_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_REMOVE_MAIL_TEMPLATE_EVENT: {
      console.log("ON_ERROR_REMOVE_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.event.delete"), }
      }
    }
    case ON_REMOVE_MAIL_TEMPLATE_EVENT: {
      console.log("ON_REMOVE_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
        mailTemplateEvents: action.payload.mailTemplateEvents
      }
    }
    case ON_START_UPDATE_MAIL_TEMPLATE_EVENT: {
      console.log("ON_START_UPDATE_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
      }
    }
    case ON_ERROR_UPDATE_MAIL_TEMPLATE_EVENT: {
      console.log("ON_ERROR_UPDATE_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.event.save"), }
      }
    }
    case ON_UPDATE_MAIL_TEMPLATE_EVENT: {
      console.log("ON_UPDATE_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
        mailTemplateEvents: action.payload.mailTemplateEvents
      }
    }
    case ON_START_GET_MAIL_TEMPLATE_EVENT: {
      console.log("ON_START_GET_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
        mailTemplateEvents:[]
      }
    }
    case ON_ERROR_GET_MAIL_TEMPLATE_EVENT: {
      console.log("ON_ERROR_GET_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Main.Template.event.get"), }
      }
    }
    case ON_GET_MAIL_TEMPLATE_EVENT: {
      console.log("ON_GET_MAIL_TEMPLATE_EVENT", action.payload)
      return {
        ...state,
        mailTemplateEvents: action.payload.mailTemplateEvents
      }
    }
    case ON_START_CREATE_MAIL_CAMPAIGN_GROUP : {
      console.log("ON_START_CREATE_MAIL_CAMPAIGN_GROUP",action.payload)
      return {
        ...state
      }
    }
    case ON_ERROR_CREATE_MAIL_CAMPAIGN_GROUP : {
      console.log("ON_ERROR_CREATE_MAIL_CAMPAIGN_GROUP",action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.group.Create"), }
      }
    }
    case ON_CREATE_MAIL_CAMPAIGN_GROUP : {
      console.log("ON_CREATE_MAIL_CAMPAIGN_GROUP",action.payload)
      return {
        ...state,
        mailCampaignGroups: action.payload.mailCampaignGroups
      }
    }
    case ON_START_UPDATE_MAIL_CAMPAIGN_GROUP : {
      console.log("ON_START_UPDATE_MAIL_CAMPAIGN_GROUP",action.payload)
      return {
        ...state
      }
    }
    case ON_ERROR_UPDATE_MAIL_CAMPAIGN_GROUP : {
      console.log("ON_ERROR_UPDATE_MAIL_CAMPAIGN_GROUP",action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.group.save"), }
      }
    }
    case ON_UPDATE_MAIL_CAMPAIGN_GROUP : {
      console.log("ON_UPDATE_MAIL_CAMPAIGN_GROUP",action.payload)
      return {
        ...state,
        mailCampaignGroups: action.payload.mailCampaignGroups
      }
    }
    case ON_START_REMOVE_MAIL_CAMPAIGN_GROUP : {
      console.log("ON_START_REMOVE_MAIL_CAMPAIGN_GROUP",action.payload)
      return {
        ...state
      }
    }
    case ON_ERROR_REMOVE_MAIL_CAMPAIGN_GROUP : {
      console.log("ON_ERROR_REMOVE_MAIL_CAMPAIGN_GROUP",action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.group.delete"), }
      }
    }
    case ON_REMOVE_MAIL_CAMPAIGN_GROUP : {
      console.log("ON_REMOVE_MAIL_CAMPAIGN_GROUP",action.payload)
      return {
        ...state,
        mailCampaignGroups: action.payload.mailCampaignGroups
      }
    }
    case ON_START_GET_MAIL_CAMPAIGN_GROUPS : {
      console.log("ON_START_GET_MAIL_CAMPAIGN_GROUPS",action.payload)
      return {
        ...state
      }
    }
    case ON_ERROR_GET_MAIL_CAMPAIGN_GROUPS : {
      console.log("ON_ERROR_GET_MAIL_CAMPAIGN_GROUPS",action.payload)
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.group.get"), }
      }
    }
    case ON_GET_MAIL_CAMPAIGN_GROUPS : {
      console.log("ON_GET_MAIL_CAMPAIGN_GROUPS",action.payload)
      return {
        ...state,
        mailCampaignGroups: action.payload.mailCampaignGroups
      }
    }
    
    case ON_START_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN: {
      return {
        ...state,
      }
    }
    case ON_ERROR_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN: {
      return {
        ...state,
        response: {type: 'error', success: false, msg: translate("Error.Campaign.group.double"), }
      }
    }
    case ON_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN: {
      return {
        ...state,
        response: {type: 'success', success: true, msg: translate("Action.Campaign.group.double"), }
      }
    }

    default: {
      return state
    }
  }
}